import { useState, useEffect, useCallback } from 'react';
import apiService from '../services/apiService'; // Centralized API service

const useBillers = (currentPage = 1, currentPageLimit = 100, refreshKey) => {
  const [billers, setBillers] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [totalPageLimit, setTotalPagesLimit] = useState(100);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchBillers = useCallback(async () => {
    setLoading(true);
    try {
      const response = await apiService.getBillers(currentPage, currentPageLimit);
      const { items, total_pages, limit } = response.data;
      setBillers(items);
      setTotalPages(total_pages);
      setTotalPagesLimit(limit);
      setError(null);
    } catch (err) {
      console.error(err);
      setError(err.message || 'Error fetching billers');
    } finally {
      setLoading(false);
    }
  }, [currentPage, currentPageLimit]);

  useEffect(() => {
    fetchBillers();
  }, [fetchBillers, refreshKey]);

  return { billers, totalPages, totalPageLimit, loading, error, refetch: fetchBillers };
};

export default useBillers;
